import { Actions } from './compounds.actions'
import { fromJS } from 'immutable'
import * as compoundsTypes from './compounds.types'

export const initialState = fromJS({
  list: {
    isLoading: false,
    shouldReload: false,
    data: [],
    queryParams: {
      page: 1,
      page_size: 20,
    },
    total: 0,
  },
  update: {
    isLoading: false,
    validationErrors: {},
    data: {},
    documents: {
      downloadDocumentLoading: false,
      isLoading: false,
      deleteDocumentLoading: false,
      data: [],
    },
    payments: {
      isLoading: false,
      data: [],
    },
    createPayment: {
      isLoading: false,
    },
    updatePayment: {
      isLoading: false,
    },
    downloadPayment: {
      isLoading: false,
    },
  },
  create: {
    isLoading: false,
    validationErrors: {},
    data: {
      compoundProperties: [],
    },
  },
})

export function compoundsReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case compoundsTypes.DELETE_COMPOUND_DOCUMENT_REQUEST: {
      return state.setIn(['update', 'documents', 'deleteDocumentLoading'], true)
    }

    case compoundsTypes.DELETE_COMPOUND_DOCUMENT_SUCCESS: {
      return state.setIn(
        ['update', 'documents', 'deleteDocumentLoading'],
        false,
      )
    }

    case compoundsTypes.DELETE_COMPOUND_DOCUMENT_FAILURE: {
      return state.setIn(
        ['update', 'documents', 'deleteDocumentLoading'],
        false,
      )
    }

    case compoundsTypes.GENERATE_COMPOUND_DOCUMENT_REQUEST: {
      return state.setIn(
        ['update', 'documents', 'generateDocumentLoading'],
        true,
      )
    }

    case compoundsTypes.GENERATE_COMPOUND_DOCUMENT_SUCCESS: {
      const newDocument = action.payload
      const newDocuments = (state.getIn(['update', 'documents', 'data']) as any)
        .toJS()
        .map((document: any) => {
          if (document.dataCycle.id === newDocument.dataCycle.id) {
            return newDocument
          }

          return document
        })

      return state
        .setIn(['update', 'documents', 'generateDocumentLoading'], false)
        .setIn(['update', 'documents', 'data'], fromJS(newDocuments))
    }

    case compoundsTypes.GENERATE_COMPOUND_DOCUMENT_FAILURE: {
      return state.setIn(
        ['update', 'documents', 'generateDocumentLoading'],
        false,
      )
    }

    case compoundsTypes.FETCH_COMPOUND_DOCUMENTS_REQUEST: {
      return state.setIn(['update', 'documents', 'isLoading'], true)
    }

    case compoundsTypes.FETCH_COMPOUND_DOCUMENTS_SUCCESS: {
      return state
        .setIn(['update', 'documents', 'isLoading'], false)
        .setIn(['update', 'documents', 'data'], fromJS(action.payload))
    }

    case compoundsTypes.FETCH_COMPOUND_DOCUMENTS_FAILURE: {
      return state.setIn(['update', 'documents', 'isLoading'], false)
    }

    case compoundsTypes.FETCH_COMPOUND_PAYMENTS_REQUEST: {
      return state.setIn(['update', 'payments', 'isLoading'], true)
    }

    case compoundsTypes.FETCH_COMPOUND_PAYMENTS_SUCCESS: {
      return state
        .setIn(['update', 'payments', 'isLoading'], false)
        .setIn(['update', 'payments', 'data'], fromJS(action.payload))
    }

    case compoundsTypes.FETCH_COMPOUND_PAYMENTS_FAILURE: {
      return state.setIn(['update', 'payments', 'isLoading'], false)
    }

    case compoundsTypes.CREATE_COMPOUND_PAYMENT_REQUEST: {
      return state.setIn(['update', 'createPayment', 'isLoading'], true)
    }

    case compoundsTypes.CREATE_COMPOUND_PAYMENT_SUCCESS: {
      const newPayments = (state.getIn(['update', 'payments', 'data']) as any)
        .toJS()
        .map((payment: any) => {
          if (payment.id == action.payload.id) {
            return action.payload
          }

          return payment
        })

      return state
        .setIn(['update', 'createPayment', 'isLoading'], false)
        .setIn(['update', 'payments', 'data'], fromJS(newPayments))
    }

    case compoundsTypes.CREATE_COMPOUND_PAYMENT_FAILURE: {
      return state.setIn(['update', 'createPayment', 'isLoading'], false)
    }

    case compoundsTypes.UPDATE_COMPOUND_PAYMENT_REQUEST: {
      return state.setIn(['update', 'updatePayment', 'isLoading'], true)
    }

    case compoundsTypes.UPDATE_COMPOUND_PAYMENT_SUCCESS: {
      const newPayments = (state.getIn(['update', 'payments', 'data']) as any)
        .toJS()
        .map((payment: any) => {
          if (payment.id == action.payload.id) {
            return action.payload
          }

          return payment
        })

      return state
        .setIn(['update', 'updatePayment', 'isLoading'], false)
        .setIn(['update', 'payments', 'data'], fromJS(newPayments))
    }

    case compoundsTypes.UPDATE_COMPOUND_PAYMENT_FAILURE: {
      return state.setIn(['update', 'updatePayment', 'isLoading'], false)
    }

    case compoundsTypes.DELETE_COMPOUND_PAYMENT_REQUEST: {
      return state
    }

    case compoundsTypes.DELETE_COMPOUND_PAYMENT_SUCCESS: {
      const newPayments = (state.getIn(['update', 'payments', 'data']) as any)
        .toJS()
        .map((payment: any) => {
          if (payment.id == action.payload.id) {
            return action.payload
          }

          return payment
        })

      return state.setIn(['update', 'payments', 'data'], fromJS(newPayments))
    }

    case compoundsTypes.DELETE_COMPOUND_PAYMENT_FAILURE: {
      return state
    }

    case compoundsTypes.DOWNLOAD_COMPOUND_PAYMENT_REQUEST: {
      return state.setIn(['update', 'downloadPayment', 'isLoading'], true)
    }

    case compoundsTypes.DOWNLOAD_COMPOUND_PAYMENT_SUCCESS: {
      return state.setIn(['update', 'downloadPayment', 'isLoading'], false)
    }

    case compoundsTypes.DOWNLOAD_COMPOUND_PAYMENT_FAILURE: {
      return state.setIn(['update', 'downloadPayment', 'isLoading'], false)
    }

    case compoundsTypes.FETCH_COMPOUNDS_REQUEST: {
      return state
        .setIn(['list', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
    }

    case compoundsTypes.FETCH_COMPOUNDS_SUCCESS: {
      return state
        .setIn(['list', 'isLoading'], false)
        .setIn(['list', 'data'], fromJS(action.payload))
        .setIn(['list', 'total'], fromJS(action.total))
    }

    case compoundsTypes.FETCH_COMPOUNDS_FAILURE: {
      return state.setIn(['list', 'isLoading'], false)
    }

    case compoundsTypes.FETCH_COMPOUND_REQUEST: {
      return state.setIn(['details', 'isLoading'], true)
    }

    case compoundsTypes.FETCH_COMPOUND_SUCCESS: {
      let newState = state
        .setIn(['update', 'isLoading'], false)
        .setIn(['update', 'data'], fromJS(action.payload))

      return newState
    }

    case compoundsTypes.FETCH_COMPOUND_FAILURE: {
      return state.setIn(['update', 'isLoading'], false)
    }

    case compoundsTypes.CREATE_COMPOUND_REQUEST: {
      return state.setIn(['create', 'isLoading'], true)
    }

    case compoundsTypes.CREATE_COMPOUND_SUCCESS: {
      return state.setIn(['create', 'isLoading'], false)
    }

    case compoundsTypes.CREATE_COMPOUND_FAILURE: {
      return state.setIn(['create', 'isLoading'], false)
    }

    case compoundsTypes.UPDATE_COMPOUND_REQUEST: {
      return state.setIn(['update', 'isLoading'], true)
    }

    case compoundsTypes.UPDATE_COMPOUND_SUCCESS: {
      return state.setIn(['update', 'isLoading'], false)
    }

    case compoundsTypes.UPDATE_COMPOUND_FAILURE: {
      return state.setIn(['update', 'isLoading'], false)
    }

    case compoundsTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case compoundsTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
